import React, { useState } from 'react';
import { Container, Tabs, Tab, Box, Typography } from '@mui/material';
import ProjectManager from './ProjectManager';
import ServiceManager from './ServiceManager';
import ProductManager from './ProductManager';
import InvoicePage from './InvoiceForm';
import MainInvoice from './MainInvoice';

const AdminDashboard = () => {
    const [tabIndex, setTabIndex] = useState(0);

    return (
        <Container sx={{ mt: 4 }}>
            <Typography variant="h4" gutterBottom>Admin Dashboard</Typography>
            <Tabs value={tabIndex} onChange={(e, newIndex) => setTabIndex(newIndex)}>
                <Tab label="Projects" />
                <Tab label="Services" />
                <Tab label="Products" />
                <Tab label="Invoices"/>
            </Tabs>

            <Box sx={{ mt: 2 }}>
                {tabIndex === 0 && <ProjectManager />}
                {tabIndex === 1 && <ServiceManager />}
                {tabIndex === 2 && <ProductManager />}
                {tabIndex === 3 && <MainInvoice />}
            </Box>
        </Container>
    );
};

export default AdminDashboard;
